import { reactive, watch } from 'cdui-js';
import '../SelectBox/style.css';
import './style.css';
import { showActionSheet } from '../ActionSheet';
import { Countries } from './Component';
import { busConfigsMaps, busConfigsTick } from '../../../../stores/bus-config';
import i18n from '../../../../i18n';

interface Props {
  title?: string;
  placeholder?: string;
  value: string | number;
  change?: any;
  /** 常用匹配关键字：支持国家文案、区号（+86 / 86）、简称（code） */
  commonKeys?: string[];
}

export const SelectCountry = (props: Props) => {
  let actionSheetIns = null;
  const state = reactive({ dictRev: 0 });

  /** App Theme / 接口国家字典晚到时刷新展示文案 */
  watch(
    () => busConfigsTick.v,
    (v) => {
      state.dictRev = v;
    },
  );

  const handleClick = () => {
    actionSheetIns = showActionSheet({
      title: props.title || i18n.Common.SelectCountryRegion,
      contentClass: 'action-sheet--select-country',
      content: () => (
        <Countries
          value={props.value}
          commonKeys={props.commonKeys}
          change={(e) => {
            props?.change?.(e);
            actionSheetIns.close();
          }}
        />
      ),
    });
  };

  const displayLabel = () => {
    void state.dictRev;
    if (!props.value) return null;
    return busConfigsMaps.countryList[props.value] || null;
  };

  return (
    <div class="f-select-box" onclick={() => handleClick()}>
      {displayLabel() ? (
        <div class="f-select-box-display">{displayLabel()}</div>
      ) : (
        <div class="f-select-box-placeholder">{props.placeholder || i18n.Common.PleaseSelect}</div>
      )}

      {/* <Icon name="common-arrow-down" class="icon-s-S icon-c-D"></Icon> */}
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.12525 11.8998C9.51442 12.2827 10.1388 12.2827 10.528 11.8998L14.2899 8.19838C14.8001 7.69631 14.4446 6.82813 13.7288 6.82813H5.92444C5.20858 6.82813 4.85308 7.69631 5.36335 8.19838L9.12525 11.8998Z"
          fill="#A2A7AD"
        />
      </svg>
    </div>
  );
};
